import {Guarantee} from '@/lib/Guarantee';
/**
 * Created by Stefann on 01/04/2019.
 */

export class PackGuarantee {
    public isSelected: boolean = false;
    constructor(public guarantee: Guarantee, public ceiling: string = '', public franchise: string = '', public premium: number = 0, public isOptional: boolean = false, public forced = false, public isChosen: boolean = false) {}

    get ceilingAmount() {
        const pattern = /^([0-9 ]+)(.*)$/;
        const match = this.ceiling.trim().match(pattern);
        if (match === null) {
            return this.ceiling.trim().length > 12 ? '' : this.ceiling.trim();
        } else {
            return match[1];
        }
    }
    get ceilingHasText(){
        return this.ceilingAmount.length < this.ceiling.trim().length;
    }
    get id(){
        return this.guarantee.id;
    }
    select(){
        this.isSelected = true;
    }
    unSelect(){
        this.isSelected = false;
    }
    toggleSelect(){
        this.isSelected = !this.isSelected;
    }
}
